const GAMIFICATION = {
  WIDTH_IN_PX: 744,
};

const CONFIG = {
  GAMIFICATION,
} as const;

export default CONFIG;
